/* global L */
import { topLeftAnchorPosition } from "./calculateAnchorOffset";

export default function getLatLngFromContainerPoint(pointX, pointY, map, style = {}) {
  const mapContainer = map.getContainer();

  const { anchorLeft, anchorTop } = topLeftAnchorPosition(style);

  const x = pointX - mapContainer.offsetLeft + anchorLeft;
  const y = pointY - mapContainer.offsetTop + anchorTop;

  return map.containerPointToLatLng(L.point(x, y));
}
